import View from './view';

export const SupportTable = View;
